import * as React from "react";
import { ComboBox } from "@/components/ui/combo-box";
import type { InvoicePublic } from "./schema";

interface InvoiceData {
  data?: InvoicePublic[];
}

interface SelectInvoiceTypeComboBoxProps {
  value: string | null;
  onChange: (value: string | null) => void;
  data: InvoiceData | undefined;
  isLoading?: boolean;
  placeholder?: string;
  triggerClassName?: string;
  contentClassName?: string;
}

export function SelectInvoiceTypeComboBox({
  value,
  onChange,
  data,
  isLoading = false,
  placeholder = "Invoice type",
  triggerClassName,
  contentClassName,
}: SelectInvoiceTypeComboBoxProps) {
  const invoiceTypes = React.useMemo(() => {
    if (!data?.data) return [];
    const uniqueTypes = new Set(data.data.map((invoice) => invoice.type).filter(Boolean));
    return Array.from(uniqueTypes).map((type) => ({
      value: type,
      label: type,
    }));
  }, [data]);

  return (
    <ComboBox<string>
      options={invoiceTypes}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      searchPlaceholder="Search type..."
      emptyMessage="No type found."
      isLoading={isLoading || !data}
      triggerClassName={triggerClassName}
      contentClassName={contentClassName}
      allowClear
    />
  );
}
